// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"NP-z","categoryName":"OP-z","categoryNameSearchHeader":"PP-z","categoryContent":"QP-z","bottomAligned":"RP-z","image":"SP-z","imageNoBackground":"TP-z"};